import Controller from './Controller'
import { trace } from 'rytm-helpers'

class LawyerFiltersController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initFilters()
  }
  addEventListeners() {
    super.addEventListeners()
    $("body").on("click", ".submit-filter", $.proxy(this.onSubmitFilters, this))
    $("body").on("click", ".reset-filter", $.proxy(this.onResetFilters, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    $("body").off("click", ".submit-filter", $.proxy(this.onSubmitFilters, this))
    $("body").off("click", ".reset-filter", $.proxy(this.onResetFilters, this))
    document.documentElement.classList.remove("advance-filter-in-use")
  }
  /**
   * OWN
   */
  initFilters() {
    this.initFilter("scope")
    this.initFilter("sector")
    this.initFilter("position")
  }
  initFilter(key) {
    const wrapper = document.querySelector('.filter-options[data-filter="' + key + '"')
    if (wrapper) {
      const optionsHtml = this.getFilterOptionsHtml(key)
      wrapper.innerHTML = optionsHtml
    }
  }
  getFilterOptionsHtml(key) {
    let html = ""
    const list = this.getFilterOptions(key)
    list.forEach((title, index) => {
      const id = "chb-" + key + "-" + index
      html += '<div class="custom-control custom-checkbox mb-1">'
      html += '<input id="' + id + '" type="checkbox" name="' + title.toLowerCase() + '" class="custom-control-input" />'
      html += '<label for="' + id + '" class="custom-control-label">' + title + '</label>'
      html += '</div>'
      html += "\r\n"
    })
    return html
  }
  getFilterOptions(key) {
    const list = this.getFilteredItemsByKey(key)
    let values = []
    let valuesTest = []
    list.forEach((el) => {
      let dataStr = el.dataset['taxon' + key.charAt(0).toUpperCase() + key.slice(1)]
      if (dataStr) {
        const dataArr = dataStr.split("|")
        dataArr.forEach((s) => {
          // w przypadku "position" rozdzielam pola po przecinku
          if (key == 'position') {
            const strArr = s.split(", ")
            strArr.forEach((str) => {
              if (str && valuesTest.indexOf(str.toLowerCase()) < 0) {
                values.push(str.toLowerCase())
                valuesTest.push(str.toLowerCase())
              }
            })
          } else {
            if (s && valuesTest.indexOf(s.toLowerCase()) < 0) {
              values.push(s.toLowerCase())
              valuesTest.push(s.toLowerCase())
            }
          }
        })
      }
    })
    values.sort()
    return values;
  }
  // zwraca elementy listy
  getFilteredItemsByKey(key) {
    return [...document.querySelectorAll('[data-taxon-' + key + ']')]
  }
  // zwraca wszystkie widoczne elementy listy (prawnicy, którzy spełniają kryteria filtra)
  getActiveFilteredItems() {
    return [...document.querySelectorAll('[data-taxon-scope]:not(.war-no-match), [data-taxon-sector]:not(.war-no-match), [data-taxon-position]:not(.war-no-match)')]
  }
  // zwraca opcje filtra [input checkbox]
  getTaxonsByKey(key) {
    return [...document.querySelectorAll('[data-filter="' + key + '"] input[type="checkbox"]')]
  }
  // zwraca wybrane opcje filtra
  getSelectedTaxonsByKey(key) {
    return [...document.querySelectorAll('[data-filter="' + key + '"] input[type="checkbox"]:checked')]
  }
  // zwraca wartości wybranych
  getSelectedTaxonValuesByKey(key) {
    let arr = []
    const list = this.getSelectedTaxonsByKey(key)
    list.forEach((el) => {
      arr.push(el.name)
    })
    return arr
  }
  uncheckSelectedTaxonsByKey(key) {
    const list = this.getSelectedTaxonsByKey(key)
    list.forEach((el) => {
      el.checked = false
    })
  }
  resetFilters() {
    const list = [...document.querySelectorAll('[data-taxon-scope], [data-taxon-sector], [data-taxon-position]')]
    list.forEach((el) => {
      el.classList.remove("war-no-match")
    })
    document.documentElement.classList.remove("advance-filter-in-use")
    document.documentElement.classList.remove("advance-filter-no-results")
  }
  filterByKey(key) {
    const selectedValues = this.getSelectedTaxonValuesByKey(key)
    const total = selectedValues.length
    if (total > 0) {
      const list = this.getFilteredItemsByKey(key)
      const dataSetKey = "taxon" + key.charAt(0).toUpperCase() + key.slice(1)
      list.forEach((el) => {
        let result = false
        const myVal = el.dataset[dataSetKey]
        if (myVal) {
          // przechodzę przez wszystkie wybrane wartości filtra
          selectedValues.forEach((str) => {
            if (myVal.toLowerCase().indexOf(str.toLowerCase()) >= 0) {
              result = true
            }
          })
        } else {
          result = false
        }
        if (!result) {
          el.classList.add("war-no-match")
        }
      })
    }
    
    return total
  }
  

  /**
   * ### EVENT handlers ###
   */
  onSubmitFilters(e) {
    e.preventDefault()
    this.resetFilters()
    // ile zaznaczono?
    let total = 0;
    total += this.filterByKey("scope")
    total += this.filterByKey("sector")
    total += this.filterByKey("position")
    if (total > 0) {
      document.documentElement.classList.add("advance-filter-in-use")
      // czy jest choć jeden aktywny?
      const listActive = this.getActiveFilteredItems()
      if (listActive.length < 1) {
        document.documentElement.classList.add("advance-filter-no-results")
      } 
    } 
  }
  onResetFilters(e) {
    e.preventDefault()
    this.uncheckSelectedTaxonsByKey("scope")
    this.uncheckSelectedTaxonsByKey("sector")
    this.uncheckSelectedTaxonsByKey("position")
    this.resetFilters()
  }


}

export default LawyerFiltersController;